import React, {ReactNode} from 'react';
import NavBar from './NavBar';


interface LayoutProps {
    children: ReactNode;  // Define the type for children
  }
  
  const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen">
      <NavBar/>
      <main>  {/* 3.5rem matches the h-14 from NavBar */}
        {children}
      </main>
    </div>
  );
};

export default Layout;

//for nav bar